export default {
  // About Admin
  "configAboutAdmin.add": "Add",
  "configAboutAdmin.details": "Details",
  "configAboutAdmin.edit": "Edit",
  "configAboutAdmin.delete": "Delete",
  "configAboutAdmin.delete.confirm.title": "Delete Configuration",
  "configAboutAdmin.delete.confirm.content": "Are you sure you want to delete this configuration?",
  "configAboutAdmin.delete.confirm.okText": "Confirm",
  "configAboutAdmin.delete.confirm.cancelText": "Cancel",
  "configAboutAdmin.modal.title": "About Configuration",
  "configAboutAdmin.thead.createdAt": "Created At",
  "configAboutAdmin.thead.updatedAt": "Updated At",
  "configAboutAdmin.thead.action": "Action",

  // About fields
  "configAboutAdmin.thead.id": "ID",
  "configAboutAdmin.thead.documentId": "Document ID",
  "configAboutAdmin.thead.itemName": "Item Name",
  "configAboutAdmin.thead.content": "Content",
  "configAboutAdmin.thead.itemId": "Item ID",
  "configAboutAdmin.thead.seo": "SEO",
  "configAboutAdmin.thead.groupId": "Group ID",
  "configAboutAdmin.thead.bindSite": "Bind Site",
  "configAboutAdmin.thead.createdBy": "Created By",
  "configAboutAdmin.thead.updatedBy": "Updated By",
  "configAboutAdmin.thead.publishedAt": "Published At",
  "configAboutAdmin.thead.locale": "Locale",
  "configAboutAdmin.thead.localizations": "Localizations",
  "configAboutAdmin.thead.status": "Status",
};
